module.exports = __webpack_public_path__ + "img/icon-action-light.16370a25.svg";